const loadedBrandPresenceScripts = new Map<string, Promise<void>>();

function loadScriptOnce(src: string): Promise<void> {
  if (loadedBrandPresenceScripts.has(src)) {
    return loadedBrandPresenceScripts.get(src) as Promise<void>;
  }

  const promise = new Promise<void>((resolve, reject) => {
    const existing = document.querySelector<HTMLScriptElement>(`script[src="${src}"]`);
    if (existing) {
      if (existing.getAttribute('data-loaded') === 'true') {
        resolve();
        return;
      }

      existing.addEventListener('load', () => resolve(), { once: true });
      existing.addEventListener('error', () => reject(new Error(`Failed to load script: ${src}`)), { once: true });
      return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.addEventListener(
      'load',
      () => {
        script.setAttribute('data-loaded', 'true');
        resolve();
      },
      { once: true }
    );
    script.addEventListener('error', () => reject(new Error(`Failed to load script: ${src}`)), { once: true });
    document.head.appendChild(script);
  });

  loadedBrandPresenceScripts.set(src, promise);
  return promise;
}

export async function loadBrandPresenceGlobalScripts(): Promise<void> {
  await loadScriptOnce('/contentDiffRenderer.js');
}
